/* eslint-disable react/no-danger */
import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { compose, defaultProps, withProps } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {withRouter} from 'react-router-dom';

import { CoreBreadcrumbs } from 'components/core/library/breadcrumbsV2';
import Crumb from './Crumb';

import './breadcrumbs.scss';

function createCrumbSchema(crumbs = [], canonicalUrl, baseUrl) {
	const origin = canonicalUrl.startsWith('/')? baseUrl + canonicalUrl : canonicalUrl;
	return {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		'@id': `${origin}#breadcrumbs`,
		itemListElement: crumbs
		.filter((crumb) => crumb.props.label)
		.map((crumb, index) => (
			{
				'@type': 'ListItem',
				position: index + 1,
				name: crumb.props.name || crumb.props.label,
				item: `${baseUrl}${get(crumb, 'props.href', '').split('?').shift()}`,
			}
		))
	};
}

export const enhance = compose(
	connect((state) => ({
		baseUrl: state.app.baseUrl
	})),
	defaultProps({ location: {} }),
	withProps(({ location, cityUrl, stateUrl, crumbs = [], canonicalUrl, baseUrl }) => {
		const newCrumbs = [];
		const { fullState, subLocality, city } = location;
		const sub = subLocality || city;
		newCrumbs.push(
			<Crumb
				href="/"
				key="base"
				label="Home"
				name="Home"
			/>
		);

		if (stateUrl) {
			newCrumbs.push(
				<Crumb
					key="state"
					href={stateUrl}
					isLast={!cityUrl && !crumbs.length}
					label={fullState}
					className="state"
				/>
			);
		}

		if (cityUrl) {
			newCrumbs.push(
				<Crumb
					key="sublocality"
					className="sublocality"
					href={cityUrl}
					isLast={!crumbs.length}
					label={`${sub} self-storage`}
				>
					{sub} <span className="self-storage">self-storage</span>
				</Crumb>
			);
		}

		return ({
			crumbs: [...newCrumbs, ...crumbs],
			crumbJSON: createCrumbSchema([...newCrumbs, ...crumbs], canonicalUrl, baseUrl)
		});
	})
);

export function Breadcrumbs({
	crumbs, crumbJSON, className
}) {
	return [
		<CoreBreadcrumbs
			key="crumbs"
			className={className}
		>
			{Children.toArray(crumbs)}
		</CoreBreadcrumbs>,
		crumbJSON && (
			<script
				key="schema"
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: JSON.stringify(crumbJSON)
				}}
			/>
		)
	].filter(Boolean);
}

Breadcrumbs.propTypes = {
	className: PropTypes.string,
	crumbs: PropTypes.node
};

export default enhance(withRouter(Breadcrumbs));
